/*!
 * Doc Swinson's — Big Thirst Cart Config
 *
 * Brand-specific config for the Big Thirst Cart engine.
 * Upload both this file and bigthirst-cart.js to bigthirst-mrdaisy Shopify theme assets.
 *
 * Squarespace setup:
 *   Settings → Website Tools → Code Injection → Header:
 *   <script src="https://checkout-6.bigthirst.com/cdn/shop/files/doc-swinsons-config.js"></script>
 *
 *   On the shop page, add a Code Block containing:
 *   <div id="bt-collection"></div>
 */

window.__BT_DOC_SWINSONS_CONFIG_VERSION = '2026-04-14-01';
console.info('[Doc Swinsons Config]', window.__BT_DOC_SWINSONS_CONFIG_VERSION);

window.BigThirstCartConfig = {
  // Collection
  collectionHandle: 'doc-swinsons-all-spirits',
  breakTitleBeforeParen: true,

  // Tracking
  ga4Id: 'G-G31XQLLBKV',
  metaPixelId: '602916347649628',

  // Inventory display
  showInventory: true,
  inventoryThreshold: 10, // shows "Only X left!" when stock ≤ 10
  inventoryInStockText: 'In Stock', // shown when stock > threshold
  inventorySoldOutText: 'Sold Out',

  // Cart copy
  cartNotice: 'All sales processed by retail partners of<br><strong>Big Thirst, Inc.</strong><br>Tax &amp; shipping calculated in next window.<br>Questions? <a href="mailto:help@bigthirst.com">help@bigthirst.com</a>',
  cartNoteSublabel: 'Discounts/Promo Codes Added During Checkout',
  cartNoteLabel: 'Order Note or Personalized Note for Recipient',
  cartNotePrefix: '-------Discounts/Promo Codes Added During Checkout----------------------Powered by Shop.BigThirst.com----------------',

  // Fonts — Google Fonts import URL
  googleFonts: 'https://fonts.googleapis.com/css2?family=Arvo:wght@400;700&family=Roboto:wght@400;700&display=swap',

  // CSS custom properties (brand theming)
  cssVars: [
    '--bt-font: "Arvo", serif;',
    '--bt-alt-font: "Roboto", sans-serif;',
    '--bt-price-color: #097d1e;',
    '--bt-price-size: 16px;',
    '--bt-text-color: #000000;',
    '--bt-title-size: 20px;',
    '--bt-border-color: #dc8991;',
    '--bt-btn-bg: #dc8991;',
    '--bt-btn-color: #ffffff;',
    '--bt-btn-hover-bg: #c27780;',
    '--bt-btn-hover-color: #ffffff;',
    '--bt-btn-px: 30px;',
    '--bt-btn-radius: 40px;',
    '--bt-img-max-height: 380px;',
    '--bt-grid-gap: 30px;',
    '--bt-grid-bottom: 50px;',
    '--bt-title-weight: normal;',
    '--bt-title-margin: 8px;',
    '--bt-title-min-height: 55px;',
    '--bt-toggle-icon-color: #ffffff;',
    '--bt-toggle-count-color: #ffffff;',
    '--bt-inventory-color: #097d1e;',
    '--bt-inventory-low-color: #c00;',
    '--bt-notice-bold-color: #000;',
    '--bt-notice-link-color: #dc8991;',
  ].join(' '),

  // Prevent host-site button hover opacity rules from washing out BT colors.
  customCSS: [
    '.bt-add-btn:hover, .bt-add-btn:focus,',
    '.bt-checkout-btn:hover, .bt-checkout-btn:focus,',
    '#bt-cart-toggle:hover, #bt-cart-toggle:focus,',
    '.bt-qty-btn:hover {',
    '  opacity: 1 !important;',
    '}'
  ].join(' '),
};

// Load the Big Thirst Cart engine
(function () {
  var s = document.createElement('script');
  s.src = 'https://checkout-6.bigthirst.com/cdn/shop/files/bigthirst-cart.js?v=2026-04-14-01';
  s.async = true;
  document.head.appendChild(s);
})();
